<template>
	<div class="container reset_password_page">
		<!-- 顶部logo -->
		<div class="toper">
			<i class="logo" @click="handleLogoClick"></i><span class="version">v2.0</span>
		</div>
		<!-- 顶部logo end-->

		<div v-loading="loading" class="main_box">
			<!-- 中间的表单部分 -->
			<div class="form_wrapper">
				<i class="cloud"></i>
				<p class="welcome">找回密码</p>

				<div class="inp_row" style="margin-top: 40px;">
					<div class="inp_row_left">
						<i class="icon_phone"></i>
					</div>
					<input ref="phone" v-model="phone" type="text" placeholder="手机号"/>
				</div>
				<div class="base_tip" style="width: 360px;"><template v-if="phoneTipDisplay"><i class="b_icon"></i>{{ phoneTipText }}</template></div>
				
				<div class="verCode_row clear_both">
					<div class="inp_row">
						<div class="inp_row_left">
							<i class="icon_verCode"></i>
						</div>
						<input ref="verCode" v-model="verCode" type="text" placeholder="验证码"/>
					</div>
					<el-button 
						type="primary" 
						:disabled="verCodeTime > 0 ? true : false" 
						@click="handleSendCodeClick"
					>{{ verCodeTime > 0 ? `${ verCodeTime }秒后点击发送` : '发送验证码' }}</el-button>
				</div>
				<div class="base_tip" style="width: 360px;"><template v-if="verCodeTipDisplay"><i class="b_icon"></i>{{ verCodeTipText }}</template></div>
				
				<div class="inp_row">
					<div class="inp_row_left">
						<i class="icon_pwd"></i>
					</div>
					<input ref="password" v-model="password" type="password" placeholder="新密码"/>
				</div>
				<div class="base_tip" style="width: 360px;"><template v-if="passwordTipDisplay"><i class="b_icon"></i>{{ passwordTipText }}</template></div>
				
				<div class="inp_row">
					<div class="inp_row_left">
						<i class="icon_pwd"></i>
					</div>
					<input ref="passwordAgain" v-model="passwordAgain" type="password" placeholder="确认密码"/>
				</div>
				<div class="base_tip" style="width: 360px;"><template v-if="passwordAgainTipDisplay"><i class="b_icon"></i>{{ passwordAgainTipText }}</template></div>

				<button class="confirm_btn" @click="handleConfirmBtnClick">确 定</button>
			</div>
			<!-- 中间的表单部分 end-->

			<!-- 底部 -->
			<div class="ft">
				<p>Copyright © 2016 合肥科飞视觉科技有限公司</p>
				<p>科飞视觉 版权所有 皖ICP备13017400号-1</p>
			</div>
			<!-- 底部 end -->
		</div>
	</div>
</template>

<script>
	import Api from '../../api/index.js'
	
	var doubleClick = false;
	export default {
		data () {
			return {
				loading: false,
				phone: "",
				verCode: "",
				password: "",
				passwordAgain: "",
				phoneTipDisplay: false,
				phoneTipText: "",
				verCodeTipDisplay: false,
				verCodeTipText: "",
				passwordTipDisplay: false,
				passwordTipText: "",
				passwordAgainTipDisplay: false,
				passwordAgainTipText: "",
				autoValidate: false,
				verCodeTime: 0
			}
		},
		mounted () {
			this.listenInput();
		},
		beforeDestroy () {
			this.verCodeInterval && clearInterval(this.verCodeInterval);
			this.interval && clearTimeout(this.interval);
		},
		methods: {
			/********************* @Listener *************************/
			// input监听
			listenInput () {
				const that = this;
				this.$refs.phone.addEventListener("focus", () => {
					var _parentEle = this.$refs.phone.parentNode;
					_parentEle.style.border = "1px solid #bb9ab0";
				}, false);
				this.$refs.verCode.addEventListener("focus", () => {
					var _parentEle = this.$refs.verCode.parentNode;
					_parentEle.style.border = "1px solid #bb9ab0";
				}, false);
				this.$refs.password.addEventListener("focus", () => {
					var _parentEle = this.$refs.password.parentNode;
					_parentEle.style.border = "1px solid #bb9ab0";
				}, false);
				this.$refs.passwordAgain.addEventListener("focus", () => {
					var _parentEle = this.$refs.passwordAgain.parentNode;
					_parentEle.style.border = "1px solid #bb9ab0";
				}, false);
				
				this.$refs.phone.addEventListener("blur", () => {
					var _parentEle = this.$refs.phone.parentNode;
					_parentEle.style.border = "1px solid #d7d7d7";
				}, false);
				this.$refs.verCode.addEventListener("blur", () => {
					var _parentEle = this.$refs.verCode.parentNode;
					_parentEle.style.border = "1px solid #d7d7d7";
				}, false);
				this.$refs.password.addEventListener("blur", () => {
					var _parentEle = this.$refs.password.parentNode;
					_parentEle.style.border = "1px solid #d7d7d7";
				}, false);
				this.$refs.passwordAgain.addEventListener("blur", () => {
					var _parentEle = this.$refs.passwordAgain.parentNode;
					_parentEle.style.border = "1px solid #d7d7d7";
				}, false);
				
				this.$refs.phone.addEventListener("input", () => {
					that.autoValidate && that.validatePhone();
				}, false);
				this.$refs.verCode.addEventListener("input", () => {
					that.autoValidate && that.validateVerCode();
				}, false);
				this.$refs.password.addEventListener("input", () => {
					that.autoValidate && that.validatePassword();
				}, false);
				this.$refs.passwordAgain.addEventListener("input", () => {
					that.autoValidate && that.validatePasswordAgain();
				}, false);
			},
			/********************* @Events *************************/
			// 点击顶部logo
			handleLogoClick () {
				this.$router.go(-1);
			},
			// 点击发送验证码
			handleSendCodeClick () {
				const that = this;
				if (doubleClick) {
					return false;
				}
				if (that.verCodeTime > 0) {
					return false;
				}
				if (!that.validatePhone()) {
					return false;
				}
				doubleClick = true;
				var _requestData = {
					phone: that.phone,
					type: "backstage_register"
				};
				Api.sendCode(_requestData).then((res) => {
					if (res.data.success) {
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.verCodeTime = 60;
						that.verCodeInterval = setInterval(() => {
							that.verCodeTime--;
							if (that.verCodeTime <= 0) {
								that.verCodeTime = 0;
								clearInterval(that.verCodeInterval);
							}
						}, 1000);
					} else {
						that.$message.error(res.data.message);
					}
					doubleClick = false;
				}, (e) => {
					that.$message.error(e.message);
					doubleClick = false;
				});
			},
			// 点击确定按钮
			handleConfirmBtnClick () {
				const that = this;
				that.autoValidate = true;
				if (!that.validatePhone()) {
					return false;
				}
				if (!that.validateVerCode()) {
					return false;
				}
				if (!that.validatePassword()) {
					return false;
				}
				if (!that.validatePasswordAgain()) {
					return false;
				}
				var _requestData = {
					borw: 2,
					newPassword: that.password,
					newPasswordToo: that.passwordAgain,
					smsCode: that.verCode,
					ucode: that.phone,
					type: "backstage",
					updateType: 1
				};
				Api.updatePassword(_requestData).then((res) => {
					if (res.data.success) {
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.interval = setTimeout(() => {
							that.$router.replace({
								path: '/login'
							});
						}, 3000);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.$message.error(e.message);
				});
			},
			/********************* @Function *************************/
			// 验证手机号
			validatePhone () {
				if (this.phoneReg.test(this.phone)) {
					this.phoneTipDisplay = false;
					this.phoneTipText = "";
					return true;
				} else {
					this.phoneTipDisplay = true;
					this.phoneTipText = "手机号格式不正确";
					return false;
				}
			},
			// 验证验证码
			validateVerCode () {
				if (this.verCodeReg.test(this.verCode)) {
					this.verCodeTipDisplay = false;
					this.verCodeTipText = "";
					return true;
				} else {
					this.verCodeTipDisplay = true;
					this.verCodeTipText = "验证码格式不正确";
					return false;
				}
			},
			// 验证新密码
			validatePassword () {
				if (this.passwordReg.test(this.password)) {
					this.passwordTipDisplay = false;
					this.passwordTipText = "";
					return true;
				} else {
					this.passwordTipDisplay = true;
					this.passwordTipText = "密码应该是6-18位字符，且不能含有空格";
					return false;
				}
			},
			// 验证确认密码
			validatePasswordAgain () {
				if (this.passwordAgain == this.password) {
					this.passwordAgainTipDisplay = false;
					this.passwordAgainTipText = "";
					return true;
				} else {
					this.passwordAgainTipDisplay = true;
					this.passwordAgainTipText = "两次密码输入不一致";
					return false;
				}
			}
		}
	}
</script>

<style scoped>
	.reset_password_page{ background-image: url(../../assets/images/body_bg.png);background-attachment: fixed; }

	.reset_password_page .toper{ display: block;position: fixed;z-index: 99;width: 100%;min-width: 1200px;height: 62px;top: 0;left: 0;padding: 0 40px;border: 1px solid #e4e4e3;background-color: #fff;box-shadow: 2px 2px 2px rgba(13, 4, 8, 0.05); }
	.reset_password_page .toper .logo{ display: inline-block;width: 105px;height: 21px;margin-top: 20px;background-image: url("../../assets/images/kefy.png");cursor: pointer;vertical-align: top; }
	.reset_password_page .toper .version{ display: inline-block;margin: 25px 0 0 10px;font-size: 16px;color: #505050;vertical-align: top; }
	
	.reset_password_page .main_box{ position: relative;min-height: 100%;padding: 62px 0 120px 0;overflow-y: auto; }
	.reset_password_page .form_wrapper{ width: 500px;height: 660px;margin: 40px auto 0;padding: 50px 0 0 0;border-radius: 6px;border: 1px solid #e4e4e3;box-shadow: 2px 2px 20px 8px rgba(13, 4, 8, 0.1);background-color: #fff; }
	.reset_password_page .form_wrapper .cloud{ display: block;width: 124px;height: 82px;margin: 0 auto;background-image: url(../../assets/images/ufly_cloud.png); }
	.reset_password_page .form_wrapper .welcome{ margin-top: 15px;font-size: 20px;color: #505050;text-align: center; }
	.reset_password_page .form_wrapper .inp_row{ position: relative;width: 360px;height: 46px;margin: 0 auto;padding: 0 0 0 48px;border: 1px solid #d7d7d7;background: #ffe7e7;font-size: 0; }
	.form_wrapper .inp_row_left{ display: block;position: absolute;z-index: 9;width: 48px;height: 44px;top: 0;left: 0;padding: 10px 0 0 0;border-right: 1px solid #d7d7d7;background: #eee;text-align: center; }
	.reset_password_page .form_wrapper .icon_phone{ display: inline-block;width: 24px;height: 24px;background-image: url(../../assets/images/login/phone.png);background-size: 100% 100%;vertical-align: top; }
	.reset_password_page .form_wrapper .icon_verCode{ display: inline-block;width: 24px;height: 24px;background-image: url(../../assets/images/login/verCode.png);background-size: 100% 100%;vertical-align: top; }
	.reset_password_page .form_wrapper .icon_pwd{ display: inline-block;width: 24px;height: 24px;background-image: url(../../assets/images/login/pwd.png);background-size: 100% 100%;vertical-align: top; }
	.reset_password_page .form_wrapper .inp_row input{ display: block;width: 100%;padding: 0 10px;background: transparent;font-size: 16px;line-height: 44px; }
	.reset_password_page .verCode_row{ width: 360px;margin: 0 auto; }
	.reset_password_page .verCode_row .inp_row{ float: left;width: 200px;margin: 0; }
	.reset_password_page .verCode_row .el-button{ float: right;width: 140px;height: 46px;font-size: 16px; }
	.reset_password_page .verCode_row .disabled{ background: #eee; }
	.reset_password_page .form_wrapper .confirm_btn{ display: block;width: 240px;height: 50px;margin: 40px auto 0;background-image: url(../../assets/images/login/dl.png);background-size: 100% 100%;color: #fff;font-size: 18px;cursor: pointer; }

	.reset_password_page .ft{ position: absolute;width: 700px;height: 80px;bottom: 30px;left: 50%;margin-left: -350px;padding: 24px 0 0 0;border-top: 1px solid #e0e0e0;font-size: 12px;color: #b1b1b1;text-align: center;line-height: 22px; }
</style>
